import React from 'react';
import {ChartSkeleton} from '../../../../components';
import {Skeleton} from '@material-ui/lab';
import styled from 'styled-components';
import {conditionalStyles} from '../../../../utils/ThemeUtils';

const ChartWrapper = styled.div`
    width: 100%;
    background-color: ${p => p.theme.muiTheme.palette.background.paper};
    padding: 25px 36px;
    border-radius: 4px;
`;

const GameIcon = styled.div`
    width: auto;
    height: auto;
    line-height: 0;

    ${p =>
        conditionalStyles(p.theme.muiTheme.direction === 'ltr')(
            'padding-right: 10px',
            'padding-left: 10px'
        )};
`;

const GameName = styled.div`
    width: 100%;
`;

const ChartHeader = styled.ul`
    position: relative;
    display: flex;
    list-style-type: none;
    justify-content: space-between;
    padding: 0;
    align-items: center;

    ${p => p.theme.muiTheme.breakpoints.down('sm')} {
        display: unset;
        & li {
            padding-bottom: 15px;
        }
    }

    & li {
        &:first-child {
            flex: 0 0 35%;
            display: flex;
            align-items: center;
        }

        ${p => p.theme.muiTheme.breakpoints.up('md')} {
            &:last-child {
                flex: '0 0 8%';
            }
        }

        ${p => p.theme.muiTheme.breakpoints.up('xl')} {
            '&:first-child' {
                flex: '0 0 40%';
            }

            '&:last-child' {
                flex: '0 0 4%';
            }
        }
    }
`;

const SupporterChartSkeleton = () => (
    <ChartWrapper>
        <ChartHeader>
            <li>
                <GameIcon>
                    <Skeleton variant="circle" width={56} height={56} />
                </GameIcon>
                <GameName>
                    <Skeleton width={100} />
                    <Skeleton width={180} />
                </GameName>
            </li>
            <li>
                <Skeleton width={100} />
                <Skeleton width={180} />
            </li>
            <li>
                <Skeleton width={100} />
                <Skeleton width={180} />
            </li>
            <li>
                <Skeleton variant="rect" width={25} height={25} style={{borderRadius: 4}} />
            </li>
        </ChartHeader>
        <ChartSkeleton
            pb={2}
            pt={4}
            height={520}
            width="100%"
            hasLegend={false}
            turnOverAxis={true}
        />
    </ChartWrapper>
);

export default SupporterChartSkeleton;
